import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/daftbqjep053ijub1utg';

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    // 先同步读取表单数据，避免遗漏浏览器自动填充
    const fd = new FormData(form);
    const honeypot = ((fd.get('company_alt') as string) || '').trim();
    // 蜜罐命中：不发送请求，仅展示与正常一致的成功反馈
    if (honeypot) {
      setStatus('success');
      setMsg('订阅成功，今天的第一份瓜讯马上送到你的邮箱。');
      form.reset();
      return;
    }
    fd.delete('company_alt');
    setStatus('loading');
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const meta = parsed?.meta as Record<string, unknown> | undefined;
      const code = parsed?.code;
      const serverMsg = (meta?.message as string) || (parsed?.message as string) || (meta?.detail as string) || responseText;
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');
      if (res.ok && code === 'OK' && !isSpam) {
        setStatus('success');
        setMsg('订阅成功，今天的第一份瓜讯马上送到你的邮箱。');
        form.reset();
      } else {
        setStatus('error');
        setMsg(typeof serverMsg === 'string' && serverMsg ? serverMsg : '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMsg('网络开小差了，请检查网络后重试。');
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-20">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl bg-primary-500 px-6 py-12 text-primary-50 md:px-14 md:py-16">
          <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary-300/30" aria-hidden="true"></div>
          <div className="pointer-events-none absolute -bottom-14 right-24 h-40 w-40 rounded-full bg-accent-400/20" aria-hidden="true"></div>
          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <p className="inline-flex items-center gap-2 rounded-full bg-primary-50/15 px-3 py-1 text-xs font-medium text-primary-50">
                <i className="ri-mail-add-line" aria-hidden="true"></i>
                每日瓜讯 · 免费订阅
              </p>
              <h2 className="mt-4 font-heading text-2xl leading-snug md:text-3xl">
                订一份瓜讯，<br className="hidden sm:block" />
                每天跟着吃瓜不迷路
              </h2>
              <p className="mt-3 max-w-md text-sm leading-6 text-primary-50/85">
                每天整理一份平台热点与讨论焦点盘点，几分钟看完当日最热话题。不刷广告、不打扰，随时可退订。
              </p>
            </div>
            <div className="lg:justify-self-end lg:pl-10">
              <form
                id="newsletter-subscribe"
                data-readdy-form="daftbqjep053ijub1utg"
                onSubmit={handleSubmit}
                className="w-full max-w-md"
              >
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                  <div className="relative flex-1">
                    <i className="ri-mail-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-primary-700" aria-hidden="true"></i>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="输入你的邮箱地址"
                      className="w-full rounded-full bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none ring-1 ring-transparent transition placeholder:text-foreground-400 focus:ring-2 focus:ring-primary-300"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={status === 'loading'}
                    className="whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 disabled:cursor-not-allowed disabled:opacity-70"
                  >
                    {status === 'loading' ? '提交中…' : '立即订阅'}
                  </button>
                </div>
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-guard"
                />
                {status === 'success' && (
                  <p className="mt-3 flex items-start gap-2 rounded-2xl bg-primary-50/15 px-4 py-3 text-sm text-primary-50">
                    <i className="ri-checkbox-circle-line mt-0.5" aria-hidden="true"></i>
                    {msg}
                  </p>
                )}
                {status === 'error' && (
                  <p className="mt-3 flex items-start gap-2 rounded-2xl bg-primary-50/15 px-4 py-3 text-sm text-primary-50">
                    <i className="ri-error-warning-line mt-0.5" aria-hidden="true"></i>
                    {msg}
                  </p>
                )}
              </form>
              <p className="mt-3 text-xs text-primary-100/80">
                点击订阅即表示同意接收吃瓜路线的定期热点推送，可随时退订。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}